export default "__VITE_ASSET__BMdJqr1l__"